/* eslint-disable @typescript-eslint/no-explicit-any */
import { VStack, TextProps, Spinner, Box } from '@chakra-ui/react';
import { useTheme } from '../../../contexts/ThemeProvider';
import { Text } from '../../../components/atoms/Text';
import { useMemo } from 'react';
import { Button } from '../../../components/atoms/Button';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { getSaleStatus } from '@/service/user/api';

export function Label(props: TextProps) {
  return <Text color="#000000" fontFamily={'Glory'} fontWeight={'400'} fontSize={14} {...props} />;
}

export function WaitingPayment({ id, link, onClose }: { id: string; link: string, onClose: () => void }) {
  const { colors } = useTheme();

  const navigate = useNavigate();

  const { isLoading, data } = useQuery('buyStatus', () => getSaleStatus(id), {
    enabled: !!id,
    refetchInterval: 60000,
    retry: 1,
  });

  const isSuccess = useMemo(() => {
    if (!data) return false;
    return data.payment_status === 'paid';
  }, [data]);

  return (
    <Box>
      {isLoading || (data && data.payment_status === 'created') ? (
        <VStack align={'center'} spacing={4}>
          <Text fontSize={20} fontFamily={'Glory'} width={'100%'} fontWeight={'bold'} textAlign={'center'}>
            Aguardando confirmação do pagamento!
          </Text>
          <Label>
            Se você já tiver realizado o pagamento, aguarde um instante, pois estamos validando a transação.
          </Label>
          <Spinner size="lg" color={colors.primaryColor} />
          <Button onClick={() => window.open(link, '_blank')}>Acessar site da compra</Button>
        </VStack>
      ) : (
        <VStack align={'center'} spacing={4}>
          {isSuccess ? (
            <Text fontSize={20} fontFamily={'Glory'} width={'100%'} fontWeight={'bold'} textAlign={'center'}>
              Pagamento confirmado!
            </Text>
          ) : (
            <Text fontSize={20} fontFamily={'Glory'} width={'100%'} fontWeight={'bold'} textAlign={'center'}>
              Pagamento recusado!
            </Text>
          )}

          {isSuccess ? (
            <Button
              onClick={() => {
                navigate('/historico');
              }}
            >
              Acessar histórico de compra
            </Button>
          ) : (
            <Button onClick={() => onClose()}>Fechar</Button>
          )}
        </VStack>
      )}
    </Box>
  );
}
